// import React from "react";
// import { FaMapMarkedAlt, FaCity, FaRoute, FaGlobeAsia } from "react-icons/fa";

// const OurNetwork = () => {
//   return (

// <>


    
// <section className="gauto-breadcromb-area section_70">
//         <div className="container">
//           <h3 className="text-center text-white">Career</h3>
//         </div>
//       </section>
//     <section className="network-section">
//       <div className="network-container">

//         {/* Header */}
//         <div className="network-header">
//           <h2>
//             Our <span>Network</span>
//           </h2>
//           <p>
//             Shambhu Cabs operates across major cities and routes, offering
//             reliable and comfortable cab services across India.
//           </p>
//         </div>

//         {/* Network Cards */}
//         <div className="network-grid">

//           {/* Mumbai Outstations */}
//           <div className="network-card">
//             <div className="network-icon">
//               <FaCity />
//             </div>
//             <h4>Mumbai Outstations</h4>
//             <p>
//               Comfortable outstation cab services from Mumbai to nearby and
//               long-distance destinations.
//             </p>
//           </div>

//           {/* Mumbai - Pune */}
//           <div className="network-card">
//             <div className="network-icon">
//               <FaRoute />
//             </div>
//             <h4>Mumbai ⇄ Pune ⇄ Mumbai</h4>
//             <p>
//               Daily cab services between Mumbai and Pune with experienced
//               drivers and well-maintained vehicles.
//             </p>
//           </div>

//           {/* Pune */}
//           <div className="network-card">
//             <div className="network-icon">
//               <FaCity />
//             </div>
//             <h4>Pune</h4>
//             <p>
//               Local and outstation cab services across Pune with timely pickups
//               and smooth travel experience.
//             </p>
//           </div>

//           {/* Nashik */}
//           <div className="network-card">
//             <div className="network-icon">
//               <FaMapMarkedAlt />
//             </div>
//             <h4>Nashik</h4>
//             <p>
//               Reliable cab services for Nashik including temple visits,
//               vineyard tours, and business travel.
//             </p>
//           </div>

//           {/* Kolhapur */}
//           <div className="network-card">
//             <div className="network-icon">
//               <FaMapMarkedAlt />
//             </div>
//             <h4>Kolhapur</h4>
//             <p>
//               Safe and comfortable cab connectivity for Kolhapur and nearby
//               destinations.
//             </p>
//           </div>

//           {/* Goa */}
//           <div className="network-card">
//             <div className="network-icon">
//               <FaGlobeAsia />
//             </div>
//             <h4>Goa</h4>
//             <p>
//               Enjoy hassle-free long-distance cab services to Goa with premium
//               vehicles and professional drivers.
//             </p>
//           </div>

//           {/* Sambhaji Nagar */}
//           <div className="network-card">
//             <div className="network-icon">
//               <FaCity />
//             </div>
//             <h4>Sambhaji Nagar (Aurangabad)</h4>
//             <p>
//               Cab services for Sambhaji Nagar including tourist and business
//               travel requirements.
//             </p>
//           </div>

//           {/* Pan India */}
//           <div className="network-card highlight">
//             <div className="network-icon">
//               <FaGlobeAsia />
//             </div>
//             <h4>Mumbai to Pan-India</h4>
//             <p>
//               Nationwide cab services from Mumbai to all major cities across
//               India with reliable fleet coverage.
//             </p>
//           </div>

//         </div>

//       </div>
//     </section>
// </>
//   );
// };

// export default OurNetwork;


import React from "react";
import { FaMapMarkedAlt, FaCity, FaRoute, FaGlobeAsia } from "react-icons/fa";

const OurNetwork = () => {
  return (
    <>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <h3 className="text-center text-white">Our Network</h3>
        </div>
      </section>

      <section className="network-section">
        <div className="network-container">
          {/* Header */}
          <div className="network-header">
            <h2>
              Our <span>Network</span>
            </h2>
            <p>
              Shambhu Cabs operates across major cities and routes, offering reliable
              and comfortable cab services across India.
            </p>
          </div>

          {/* Network Cards */}
          <div className="network-grid">

            {/* Existing Cities */}
            <div className="network-card">
              <div className="network-icon">
                <FaCity />
              </div>
              <h4>Mumbai Outstations</h4>
              <p>Comfortable outstation cab services from Mumbai to nearby and long-distance destinations.</p>
            </div>

            <div className="network-card">
              <div className="network-icon">
                <FaRoute />
              </div>
              <h4>Mumbai ⇄ Pune ⇄ Mumbai</h4>
              <p>Daily cab services between Mumbai and Pune with experienced drivers and well-maintained vehicles.</p>
            </div>

            <div className="network-card">
              <div className="network-icon">
                <FaCity />
              </div>
              <h4>Pune</h4>
              <p>Local and outstation cab services across Pune with timely pickups and smooth travel experience.</p>
            </div>

            <div className="network-card">
              <div className="network-icon">
                <FaMapMarkedAlt />
              </div>
              <h4>Nashik</h4>
              <p>Reliable cab services for Nashik including temple visits, vineyard tours, and business travel.</p>
            </div>

            <div className="network-card">
              <div className="network-icon">
                <FaMapMarkedAlt />
              </div>
              <h4>Kolhapur</h4>
              <p>Safe and comfortable cab connectivity for Kolhapur and nearby destinations.</p>
            </div>

            <div className="network-card">
              <div className="network-icon">
                <FaGlobeAsia />
              </div>
              <h4>Goa</h4>
              <p>Enjoy hassle-free long-distance cab services to Goa with premium vehicles and professional drivers.</p>
            </div>

            <div className="network-card">
              <div className="network-icon">
                <FaCity />
              </div>
              <h4>Sambhaji Nagar (Aurangabad)</h4>
              <p>Cab services for Sambhaji Nagar including tourist and business travel requirements.</p>
            </div>

            {/* New Maharashtra Cities */}
            <div className="network-card">
              <div className="network-icon">
                <FaCity />
              </div>
              <h4>Shirdi</h4>
              <p>Convenient cab services to Shirdi for pilgrims and tourists from major cities.</p>
            </div>

            <div className="network-card">
              <div className="network-icon">
                <FaCity />
              </div>
              <h4>Nagpur</h4>
              <p>Reliable cab connectivity for Nagpur including city travel and outstation trips.</p>
            </div>

            <div className="network-card">
              <div className="network-icon">
                <FaCity />
              </div>
              <h4>Satara</h4>
              <p>Comfortable cab services in Satara for sightseeing and business purposes.</p>
            </div>

            <div className="network-card">
              <div className="network-icon">
                <FaCity />
              </div>
              <h4>Solapur</h4>
              <p>Safe and timely cab services in Solapur connecting nearby cities and destinations.</p>
            </div>

            {/* Pan India */}
            <div className="network-card highlight">
              <div className="network-icon">
                <FaGlobeAsia />
              </div>
              <h4>Mumbai to Pan-India</h4>
              <p>Nationwide cab services from Mumbai to all major cities across India with reliable fleet coverage.</p>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default OurNetwork;
